import MyAddress from './../entities/MyAddress'
export class GetAddressDetailsFilter {
    public Address: MyAddress;
}

export default GetAddressDetailsFilter;